import {createStore as reduxCreateStore, combineReducers} from 'redux'
// import * as Sentry from "@sentry/react"

/**
 * Wraps a reducer to supply correct initial data
 * 'replaceReducer' doesn't allow you to specify initial data which requires
 * injected reducers to be wrapped by this function.
 */
function createReducer(reducer, initialState){
  return function(state, action){
    if (action.type.startsWith('@@redux/REPLACE')){   // action redux uses for initialization
      return reducer(initialState, action)
    }
    return reducer(state, action)
  }
}

/**
 * Allows for injecting reducers dynamically later (useful for our modular codebase)
 * Inspired by: http://stackoverflow.com/questions/32968016/how-to-dynamically-load-reducers-for-code-splitting-in-a-redux-application/33044701#33044701
 *
 * Use:
 *   store.injectReducers({'namespace': reducerFunction})
 *
 */
export function createStore(reducers, initialState) {
  const store = reduxCreateStore(combineReducers(reducers), initialState)
  store.curReducers = reducers

  function registerReducer(reducer, namespace, replace=false) {
    if (!store.curReducers[namespace] || replace) {
      store.curReducers[namespace] = createReducer(reducer, initialState[namespace])
    } else {
      // Sentry.withScope(function(scope) {
      //   scope.setExtras({ reducerNamespace: namespace })
      //   Sentry.captureMessage("Duplicate redux reducer", "info")
      // })
    }
    store.replaceReducer(combineReducers(store.curReducers))
  }

  store.registerReducer = registerReducer
  return store
}


/**
 * Decorator to register reducers with the central store
 *
 * You must provide a namespace inside the store's state for the reducer to govern.
 */
export function registerReducer(reducer, namespace, replace=false){
  // automatically start the store if it doesn't exist
  if (!window.cm.store){
    // Set up redux store
    const initialState = window.cm.initialState || {}
    const reducers = {[namespace]: reducer}
    initialState.user = window.cm.studiosUser
    // various spots depend on state.user in @connect for effectively static data on the user, we
    // provide a default reducer that can be overriden in apps that actually have actions operating
    // on user.
    if (namespace !== 'user') {
      reducers['user'] = (state, _action) => state || {}
    }
    window.cm.store = createStore(reducers, initialState)
  } else {
    window.cm.store.registerReducer(reducer, namespace, replace)
  }
}
